// Module
var code = "<ap-laser-request-trainings-grid\n        title=\"{{$ctrl.title}}\">\n</ap-laser-request-trainings-grid>\n\n<tabs-navigation identifier=\"{{$ctrl.identifier}}\"\n                 state=\"{{$ctrl.state}}\"\n                 on-exec=\"$ctrl.onApprove($event)\">\n</tabs-navigation>\n";
// Exports
module.exports = code;